import { throttle } from 'lodash';
import fpApi from 'fp-api';
import config from '../config';

const { onesportPlatform, onesportSource } = config.settings;

const onesportApi = fpApi({
  baseURI: onesportSource
});

const apiVersion = 'v1';

function endpoint(endpointKey, endpointType, throttleTime = 0) {
  const widgetFunc = (sportId, entityId, endpointValue) =>
    onesportApi.get(
      `sport/${sportId}/api/${apiVersion}/widgets/${endpointKey}/${endpointValue}/${endpointType}/${entityId}/summary?platform=${onesportPlatform}`
    );

  if (throttleTime > 0) {
    return throttle(widgetFunc, throttleTime, { trailing: false });
  }

  return widgetFunc;
}

export const fetchPlayerCompetitionData = endpoint('competition', 'player');
export const fetchPlayerGameData = endpoint('game', 'player');
export const fetchPlayerGameDataThrottle = endpoint('game', 'player', 1000);
export const fetchPlayerSeasonData = endpoint('season', 'player');
export const fetchTeamCompetitionData = endpoint('competition', 'team');
export const fetchTeamGameData = endpoint('game', 'team');
export const fetchTeamGameDataThrottle = endpoint('game', 'team', 1000);
